import { GearIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { FC } from 'react'

export const InspectionGridSettingsButton: FC = () => {
  const { setInspectionGridSettingsOpen } = useKestrelViewerContext()

  return (
    <TooltipWrapper side={'top'} offset={5} label={'Inspection Grid Settings'}>
      <ViewToggle onClick={() => setInspectionGridSettingsOpen(true)}>
        <GearIcon width={22} height={22} style={{ color: 'white' }} />
      </ViewToggle>
    </TooltipWrapper>
  )
}
